import { useLocation } from 'react-router-dom';
export var useAppIdFromURL = function () {
    var pathname = useLocation().pathname;
    var pathNameArray = pathname.split('/');
    return pathNameArray[4];
};
export var useOrgIdFromURL = function () {
    var pathname = useLocation().pathname;
    var pathNameArray = pathname.split('/');
    return pathNameArray[2];
};
